import { render, staticRenderFns } from "./viewPostWork.vue?vue&type=template&id=3b541bf4&"
import script from "./viewPostWork.vue?vue&type=script&lang=js&"
export * from "./viewPostWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports